module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/13-8581c85765ebc40df4027511a69a3221.png";